import { createSaga } from './saga-helpers';

import * as Api from '../api/user-state-api';

const watchGetState = createSaga({
    type: 'USER_STATE_FETCH',
    fn: Api.fetchUserState,
    args: action => [action.payload],
    successPayload: (state, action) => ({
        state,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchUpdateChatsUserState = createSaga({
    type: 'USER_STATE_CHATS_UPDATE',
    fn: Api.updateChatsUserState,
    args: action => [action.payload],
    successPayload: (state, action) => ({ state })
});

const watchUpdateSubteamsUserState = createSaga({
    type: 'USER_STATE_SUBTEAMS_UPDATE',
    fn: Api.updateSubteamsUserState,
    args: action => [action.payload],
    successPayload: state => ({ state })
});

const watchUpdateProjectUserState = createSaga({
    type: 'USER_STATE_PROJECT_UPDATE',
    fn: Api.updateProjectUserState,
    args: action => [action.payload.projectId, action.payload.projectState],
    successPayload: state => ({ state })
});

const watchUpdateProjectTasksUserState = createSaga({
    type: 'USER_STATE_PROJECT_TASKS_UPDATE',
    fn: Api.updateProjectUserState,
    args: action => [action.payload.projectId, action.payload.projectTasksState],
    successPayload: state => ({ state })
});

const watchUpdateAllTasksUserState = createSaga({
    type: 'USER_STATE_ALL_TASKS_UPDATE',
    fn: Api.updateAllTasksUserState,
    args: action => [action.payload],
    successPayload: state => ({ state })
});

const watchUpdateMyTasksUserState = createSaga({
    type: 'USER_STATE_MY_TASKS_UPDATE',
    fn: Api.updateMyTasksUserState,
    args: action => [action.payload],
    successPayload: state => ({ state })
});

const watchUpdateWorkloadsUserState = createSaga({
    type: 'USER_STATE_WORKLOADS_UPDATE',
    fn: Api.updateWorkloadsState,
    args: action => [action.payload],
    successPayload: state => ({ state })
});

const sagas = [watchGetState, watchUpdateChatsUserState, watchUpdateSubteamsUserState, watchUpdateProjectUserState, watchUpdateProjectTasksUserState, watchUpdateAllTasksUserState, watchUpdateMyTasksUserState, watchUpdateWorkloadsUserState];

export default sagas;
